import { apiCMSWithToken } from './axios'

export const url = {
  recruitment: `/recruitment`
}

export async function recruitmentSearch(filters = {}) {
  try {
    
    const params = new URLSearchParams(filters).toString()
    const response = await apiCMSWithToken.get(
      `${url.recruitment}?${params}`
    )
    return response
  } catch (error) {
    console.error('Error in requestSearch:', error)
    throw error
  }
}

export async function recruitmentUpdate(body, id) {
  const response = await apiCMSWithToken.put(
    `${url.recruitment}/${id}`,
    body
  )
  return response
}

export async function recruitmentDetail(id) {
  try {
    const response = await apiCMSWithToken.get(
      `${url.recruitment}/${id}`
    )

    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function showRecruitmentPhone(id) {
  const response = await apiCMSWithToken.get(
    `${url.recruitment}/${id}/show-phone`
  )
  return response
}

export async function recruitmentDelete(id, body) {
  const response = await apiCMSWithToken.delete(
    `${url.recruitment}/${id}`,
    {
      ...body
    }
  )
  return response
}


export default {
  recruitmentSearch,
  recruitmentUpdate,
  recruitmentDetail,
  showRecruitmentPhone,
  recruitmentDelete
  }
  
